<template>
  <section class="feedback">
    <div class="text">
        <span class="success-logo">
            <img src="../assets/images/icons/check-mark-success.gif" />
        </span>
        <p class="thanks-text">Thanks for rating</p>
      <p class="info-message">Your rating submitted Successfully.</p>
      <router-link tag="span" :to="{ path: '/'}" class="btn">Go to home page >></router-link>
    </div>    
  </section>
</template>
<script>
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
export default {
  name: "ShopFeedbackResult",
  components: {
  },
  data() {
    return {
    };
  },

  methods: {
    getOrderFeedback() {
      this.loading = true;
      ApiCaller(
        constant.PRODUCT_RATING,
        "get-order-rating-by-user/" + this.$route.params.orderId,
        "get"
      )
        .then(data => {
          this.loading = false;
           this.orderDetails = data.data;
          setTimeout(() => {
            if (!this.$route.query.ratingId) {
              this.getScratchValue();
            }
          }, 1000);         
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    
  },
  mounted() {
    // this.getOrderFeedback();
  }
};
</script>
<style lang="scss" scoped>
.feedback {
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  .text {
    margin-bottom: -120px;
    padding-top: 80px;
    text-align: center;
    p {
      font-size: 1.1em;
      line-height: 26px;
      padding: 0 45px;
    }
    .success-logo{
        width: 120px;
        height: 120px;
        display: block;
        margin: 0 auto;
        img{
            max-width: 100%;
            max-height: 100%;
        }
    }
    .thanks-text{
        font-size: 1.25em;
        margin: 16px 0;
        font-weight: 600;
    }
    .info-message{
        font-size: 0.875em;
    }

  }
  .btn {
        width: max-content;
    background-color: #fff;
    padding: 10px 25px;
    text-align: center;
    border-radius: 8px;
    color: #118709;
    font-size: 0.875em;
    display: block;
    margin: 25px auto;
    border: 1px solid #118709;
    font-weight: 500;
  }
}
</style>